module.exports = __webpack_public_path__ + "media/img/auth/brain-hero-01bdd39a23a7f8263114d82e7772c782.svg";